import { Component, OnInit } from '@angular/core';
import { AssignJeevesDefaultsComponent, JeevesDeliveryAddressesService } from 'gung-standard-jeeves';
import {
  SelectedCustomerService,
  AuthService,
  Customer,
  AvailabilityService,
  CartService,
  CustomerContactService,
  CustomerService,
  GungFlowService,
  CartRow,
  CustomerContact,
  GungFlow
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { first } from 'rxjs';
import { User } from 'gung-standard/lib/state/auth/types';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'ref-ref-checkout-defaults',
    templateUrl: './ref-checkout-defaults.component.html',
    styleUrls: ['./ref-checkout-defaults.component.scss'],
    standalone: false
})
export class RefCheckoutDefaultsComponent extends AssignJeevesDefaultsComponent implements OnInit {
  private user: User;
  private confirmationEmail = 'heather.york@refstockholm.com';

  isRef =  environment.projectName === 'ref';

  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected customerContactService: CustomerContactService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected availabilityService: AvailabilityService,
    protected dateUtilService: DateUtilService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService
  ) {
    super(
      selectedCustomerService,
      customerService,
      customerContactService,
      gungFlowService,
      authService,
      cartService,
      availabilityService,
      dateUtilService,
      jeevesDeliveryAddressesService
    );
  }

  ngOnInit() {
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.user = user;
        super.ngOnInit();
      });
  }

  protected setValues(
    customer: Customer,
    flow: GungFlow,
    user,
    customerContacts: CustomerContact[],
    billingCustomer?: Customer,
    cartRows?: CartRow[]
  ) {
    super.setValues(customer, flow, user, customerContacts, billingCustomer, cartRows);

    if (this.user.email) {
      if (!this.checkout.extra.confirmationEmails) {
        this.checkout.extra.confirmationEmails = [];
      }
      this.checkout.extra.confirmationEmails.push(this.user.email);
    }

    if (this.isRef && customer.extra.kus.kundkategorikod === 6 || customer.extra.kus.kundkategorikod === '6') {
      this.checkout.extra.oh.ordstat = 0;
      if (!this.checkout.extra.confirmationEmails) {
        this.checkout.extra.confirmationEmails = [];
      }
      this.checkout.extra.confirmationEmails.push(this.confirmationEmail);
    }
  }
}
